import { Component, OnInit } from '@angular/core';
import { IHRBMicroUiConfig } from '../shared/interfaces/hrblock-micro-ui-config-interface';
import { microApps } from '../shared/services/config';
import { microUI } from '../shared/constants';
import { AnalyticsService } from '../shared/services/analytics.service';
import { DataService } from '../shared/services/data.service';

@Component({
  selector: 'app-confirmation-page',
  templateUrl: './confirmation-page.component.html',
  styleUrls: ['./confirmation-page.component.scss']
})
export class ConfirmationPageComponent implements OnInit {

  public email : string;
  public product : string;
  public preOrderEnabled : boolean;

  constructor(private analyticsService : AnalyticsService, private dataService : DataService) { }

  ngOnInit() {
    console.log("confirmation-page.component:ngOnInit() ...");

    this.analyticsService.cartPageLoad("order confirmation");
    console.log("confirmation-page.component:ngOnInit() step 1 cartPageLoad");

    this.email =  this.dataService.getBillingEmail();
    console.log("confirmation-page.component:ngOnInit() step 2 getBillingEmail");

    this.product = this.dataService.getProductDescription();
    console.log("confirmation-page.component:ngOnInit() step 3 getProductDescription");

    this.preOrderEnabled = this.dataService.getPreOrder().preOrderEnabled;
    console.log("confirmation-page.component:ngOnInit() done");
  }

  public OrderConfirmation: IHRBMicroUiConfig = microApps[microUI.orderConfirmation];

}
